import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import useDocumentTitle from "../../components/helpers/useDocumentTitle";
import PageHeader from "../../components/shared/PageHeader";
import PageMain from "../../containers/shared/PageMain";
import apiClient from "../../components/utils/apiClient";
import MainContent from "../../containers/shared/MainContent";
import NormalFormContainer from "../../containers/shared/NormalFormContainer";
import InputField from "../../components/shared/InputField";
import SelectField from "../../components/shared/SelectField";
import ModalContainer from "../../containers/shared/ModalContainer";
import NormalButton from "../../components/shared/NormalButton";
import SingleImageUpload from "../../components/shared/SingleImageUpload";
import Toast from "../../components/shared/Toast";
import Loading from "../../components/shared/Loading";
import useUser from "../../components/helpers/useUser";

const WalletPage = () => {
  const { t, i18n } = useTranslation();
  useDocumentTitle(t('wallet.pageTitle'));
  const navigate = useNavigate();
  const pageTitle = { title: t('wallet.pageTitle') };
  const [user, setUser] = useUser();
  const [transactions, setTransactions] = useState(null);
  const [vendor, setVendor] = useState(null);
  const [totalTransactions, setTotalTransactions] = useState(0);
  const [rechargeModal, setRechargeModal] = useState(false);
  const [rechargeAmount, setRechargeAmount] = useState("");
  const [isRechargeDisabled, setIsRechargeDisabled] = useState(true);
  const [searchParams, setSearchParams] = useSearchParams();
  const [showLoading, setShowLoading] = useState(false);
  const [toast, setToast] = useState({ show: false, type: null, message: "" });
  const [pageSize, setPageSize] = useState(8);
  const [currentPage, setCurrentPage] = useState(1);
  const [pagesCount, setPagesCount] = useState(null);

  const [withDrawWalletModal, setWithDrawWalletModal] = useState(false);

  const [showExportModal, setShowExportModal] = useState(false);
  const [withDrawAmount, setWithDrawAmount] = useState("");
  const [iswithDrowDisabled, setIswithDrowDisabled] = useState(true);

  const getTransactions = async () => {
    try {
      const response = await apiClient.get(
        `/transactions?vendorsId=${user?._id}`,
      );
      if (response?.data) {
        const transaction = response?.data;
        setTransactions(transaction);
        setTotalTransactions(response?.data?.length);
        const pagesCount = response?.data?.length / pageSize;
        
      } else {
      }
    } catch (err) {}
  };

  useEffect(() => {
    getTransactions();
  }, [currentPage]);

  const getUserData = async () => {
    try {
      const response = await apiClient.get(`vendors/${user?._id}`);
      if (response?.data) {
        setVendor(response?.data);
      } else {
      }
    } catch (err) {}
  };

  useEffect(() => {
    if (user && user?._id) {
      getUserData();
    }
  }, [user]);

  const handleCloseModal = () => {
    setRechargeModal(false);
    setWithDrawWalletModal(false);
  };

  const handleClickRechargeWallet = () => {
    setRechargeModal(true);
    setRechargeAmount("");
    setIsRechargeDisabled(true);
  };

  useEffect(() => {
    if (rechargeAmount !== "" && rechargeAmount > 0) {
      setIsRechargeDisabled(false);
    } else {
      setIsRechargeDisabled(true);
    }
  }, [rechargeAmount]);

  useEffect(() => {
    if (withDrawAmount !== "" && withDrawAmount > 0) {
      setIswithDrowDisabled(false);
    } else {
      setIswithDrowDisabled(true);
    }
  }, [withDrawAmount]);

  const handleRechargeAction = async () => {
    setIsRechargeDisabled(true);
    let callback;
    callback = window?.location?.href;
    try {
      const response = await apiClient.post(`/vendors/recharge`, {
        amount: rechargeAmount,
        frontEndCallback: callback,
      });
      if (response?.data) {
        window.location.href = response?.data?.formUrl;
        return false;
      } else {
        setIsRechargeDisabled(false);
      }
    } catch (err) {
      setIsRechargeDisabled(false);
      setToast({
        show: true,
        type: "error",
        message: err?.response?.data?.message,
      });
    }
  };

  useEffect(() => {
    if (searchParams.get("status") && searchParams.get("status") === "paid") {
      setToast({
        show: true,
        type: "success",
        message: t('wallet.paymentSuccess'),
      });
    }
    if (searchParams.get("status") && searchParams.get("status") !== "paid") {
      setToast({
        show: true,
        type: "error",
        message: t('wallet.paymentError'),
      });
    }
  }, []);

  const handleClickChangePage = (page) => {
    setCurrentPage(page);
  };

  const handleWithDrawWallet = () => {
    setWithDrawWalletModal(true);
    setWithDrawAmount("");
    setIswithDrowDisabled(true);
  };

  const handleWithDrawWalletAction = async () => {
    if (withDrawAmount > 0) {
      if (withDrawAmount > vendor.credits) {
        setToast({
          show: true,
          type: "error",
          message: t('wallet.withdrawError'),
        });
      } else {
        const body = {
          amount: withDrawAmount,
          mobileNumber: vendor.username,
        };
        try {
          const response = await apiClient.post(`/vendors/withdraw`, body);
          if (
            response &&
            response.status &&
            (response.status === 201 || response.status === 200)
          ) {
            // console.log(response.data);
            setToast({
              show: true,
              type: "success",
              message: response.data.message,
            });
            setWithDrawAmount("");
            getUserData();
            setWithDrawWalletModal(false);
            // window.location.href = response.data.formUrl;
          } else {
          }
        } catch (error) {
          setToast({
            show: true,
            type: "error",
            message: error?.response?.data?.message,
          });
        }
      }
    } else {
      setToast({
        show: true,
        type: "error",
        message: t('wallet.withdrawAmountError'),
      });
    }
  };

  return (
    <>
      <div>
        <PageHeader pageTitle={pageTitle} />
        <PageMain>
          <div className="absolute top-0 left-0 w-full h-full bg-grey-50 z-0"></div>
          {vendor && transactions && (
            <MainContent>
              <div className="flex flex-wrap lg:flex-nowrap gap-x-[20px] gap-y-[20px] mt-[15px]">
                <div className="w-full lg:w-[calc(100%-325px)] overflow-x-auto order-2 lg:order-1">
                  {vendor?.MinimumWalletBalance &&
                    vendor?.MinimumWalletBalance > vendor?.credits && (
                      <div className="mb-[16px] h-[46px] leading-[46px] bg-infoLight text-info text-[16px] font-[600] rounded-[12px] px-[12px] cairo-font relative">
                        <img
                          src="/assets/images/info-circle-info.svg"
                          alt=""
                          className="inline-block me-[8px]"
                        />
                        {t('wallet.minBalanceWarning')}{" "}
                        {vendor?.MinimumWalletBalance} {t('wallet.minBalanceWarning2')}
                      </div>
                    )}

                  {Array.isArray(transactions) && transactions?.length > 0 ? (
                    <>
                      <div className="w-full overflow-x-auto">
                      <table
                        className="w-full border border-darkblue rounded-[8px] border-separate overflow-hidden"
                        cellSpacing={0}
                        dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
                      >
                        <thead>
                          <tr className="border-b-[2px] border-b-grey-50">
                            <th className="bg-darkBlue text-white leading-[56px] rounded-ss-[8px] text-start px-[15px] text-[16px] font-[500px] w-[60px] rtl:border-l-[1px] rtl:border-l-grey-100 ltr:border-r-[1px] ltr:border-r-grey-100">
                              {t('wallet.transactionType')}
                            </th>
                            <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] rtl:border-l-[1px] rtl:border-l-grey-100 ltr:border-r-[1px] ltr:border-r-grey-100">
                              {t('wallet.transactionMemo')}
                            </th>
                            <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] w-[128px] rtl:border-l-[1px] rtl:border-l-grey-100 ltr:border-r-[1px] ltr:border-r-grey-100">
                              {t('wallet.transactionAmount')}
                            </th>
                            <th className="bg-darkBlue text-white leading-[56px] rounded-se-[8px] text-start px-[15px] text-[16px] font-[500px] w-[128px]">
                              {t('wallet.transactionDate')}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {transactions
                            .slice(
                              currentPage * pageSize - pageSize,
                              currentPage * pageSize,
                            )
                            .map((transaction, index) => {
                              return (
                                <tr key={`transactions-${index}`}>
                                  <td
                                    className={`${index % 2 === 0 ? "bg-white" : "bg-grey-100"} leading-[40px] px-[15px] text-grey-900 font-[500] text-[14px] whitespace-nowrap text-center`}
                                  >
                                    { transaction?.worth > 0 ? (
                                        <div className="text-success">
                                          <span
                                            className="w-[16px] h-[16px] !bg-center !bg-no-repeat inline-block align-middle ltr:scale-x-[-1]"
                                            style={{
                                              background:
                                                'url("/assets/images/received.svg")',
                                            }}
                                          ></span>
                                        </div>
                                      )
                                      : (
                                        <div className="text-danger">
                                          <span
                                            className="w-[16px] h-[16px] !bg-center !bg-no-repeat inline-block align-middle ltr:scale-x-[-1]"
                                            style={{
                                              background:
                                                'url("/assets/images/send.svg")',
                                            }}
                                          ></span>
                                        </div>
                                      )}
                                  </td>
                                  <td
                                    className={`${index % 2 === 0 ? "bg-white" : "bg-grey-100"} whitespace-nowrap leading-[40px] px-[15px] text-grey-900 font-[500] text-[14px]`}
                                  >
                                      {transaction?.memo || t('wallet.unknown')}
                                  </td>
                                  <td
                                    className={`${index % 2 === 0 ? "bg-white" : "bg-grey-100"} leading-[40px] px-[15px] text-grey-900 font-[500] text-[14px] !text-right whitespace-nowrap`}
                                  >
                                    {transaction?.worth?.toFixed(2) || '0.00'}{" "}
                                    <img
                                      src="/assets/images/SAR-med.svg"
                                      alt=""
                                      className="inline-block w-[11px]"
                                    />
                                  </td>
                                  <td
                                    className={`${index % 2 === 0 ? "bg-white" : "bg-grey-100"} leading-[40px] px-[15px] text-grey-900 font-[500] text-[14px] whitespace-nowrap`}
                                  >
                                    {new Date(
                                      transaction?.createdAt,
                                    ).toLocaleDateString(i18n.language === 'ar' ? "ar-eg" : "en-GB", {
                                      year: "numeric",
                                      month: "long",
                                      day: "numeric",
                                    })}
                                  </td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                      </div>
                      <div className="flex my-[24px]">
                        <div className="w-[50%] text-grey-600 font-[500] leading-[24px] text-[16px]">
                          {t('wallet.showing')} {currentPage * pageSize - (pageSize - 1)} {t('wallet.to')}{" "}
                          {Math.min(
                            currentPage * pageSize,
                            transactions?.length,
                          )}{" "}
                          {t('wallet.of')} {transactions?.length} {t('wallet.transactions')}
                        </div>
                        <div className="w-[50%] text-end">
                          <div className="inline-block">
                            <ul className="ml-auto flex items-center">
                              <li
                                className={`font-[500] text-[14px] w-[24px] h-[28px] leading-[28px] text-grey-300 bg-white cursor-pointer text-center me-[1px] rounded-s-[8px] ${currentPage === 1 && "pointer-events-none"}`}
                                onClick={() =>
                                  handleClickChangePage(currentPage - 1)
                                }
                              >
                                <img
                                  src="/assets/images/arrow-left-blue.svg"
                                  className={`${currentPage === 1 && "pointer-events-none opacity-50"} rtl:rotate-180 w-[20px] h-[20px] mx-[2px] my-[4px]`}
                                  alt=""
                                />
                              </li>
                              {[...Array(pagesCount).keys()].map(
                                (page, index) => (
                                  <li
                                    key={`pageNumber${page}-${index}`}
                                    className={`me-[1px] font-[500] text-[14px] w-[24px] h-[28px] leading-[28px] bg-white cursor-pointer text-center text-orange pointer-events-none`}
                                    
                                  >
                                    {currentPage}
                                  </li>
                                ),
                              )}
                              <li
                                className={`font-[500] text-[14px] w-[24px] h-[28px] leading-[28px] text-grey-300 bg-white cursor-pointer text-center me-[1px] rounded-s-[8px] ${transactions?.slice(
                              currentPage * pageSize - pageSize,
                              currentPage * pageSize,
                            )?.length < pageSize && "pointer-events-none"}`}
                                onClick={() =>
                                  handleClickChangePage(currentPage + 1)
                                }
                              >
                                <img
                                  src="/assets/images/arrow-left-blue.svg"
                                  className={`${currentPage === pagesCount && "pointer-events-none opacity-50"} w-[20px] h-[20px] mx-[2px] my-[4px] ltr:rotate-180`}
                                  alt=""
                                />
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className="pt-[80px] text-center">
                      <div
                        className="inline-block w-[188px] h-[188px] !bg-contain !bg-center"
                        style={{
                          background: "url('/assets/images/wallet-search.svg')",
                        }}
                      ></div>
                      <div className="w-full text-center text-grey-900 text-[24px] font-[500] mb-[25px]">
                        {t('wallet.noTransactions')}
                      </div>
                    </div>
                  )}
                </div>
                <div className="w-full lg:w-[325px] order-1 lg:order-2">
                  <div
                    className="w-full lg:w-[324px] h-[186px] relative !bg-center !bg-no-repeat mb-[10px] !bg-cover !lg:bg-contain rounded-[12px] lg:rounded-0"
                    style={{
                      background: "url('/assets/images/wallet-card.svg')",
                    }}
                  >
                    <div
                      className="w-[65px] h-[24px] absolute top-[15px] start-[15px] !bg-contain !bg-no-repeat"
                      style={{
                        background: "url('/assets/images/logo-white.svg')",
                      }}
                    ></div>
                    <div className="absolute bottom-[15px] end-[15px] text-white font-[500] text-[14px] leading-[21px]">{t('wallet.walletBalance')}</div>
                    <div className="w-full leading-[186px] relative z-[1] text-white text-center font-[700] text-[38px]">
                      {vendor?.credits?.toFixed(2) || '0.00'}{" "}
                      <img
                        src="/assets/images/white-sar.svg"
                        alt=""
                        className="inline-block align-baseline"
                      />
                    </div>
                  </div>
                  <div
                    className="w-full lg:w-[324px] h-[186px] relative !bg-center !bg-no-repeat mb-[10px] !bg-cover !lg:bg-contain rounded-[12px] lg:rounded-0"
                    style={{
                      background: "url('/assets/images/wallet-card.svg')",
                    }}
                  >
                    <div
                      className="w-[65px] h-[24px] absolute top-[15px] start-[15px] !bg-contain !bg-no-repeat"
                      style={{
                        background: "url('/assets/images/logo-white.svg')",
                      }}
                    ></div>
                    <div className="absolute bottom-[15px] end-[15px] text-white font-[500] text-[14px] leading-[21px]">{t('wallet.incomeBalance')}</div>
                    <div className="w-full leading-[186px] relative z-[1] text-white text-center font-[700] text-[38px]">
                      {vendor?.income?.toFixed(2) || '0.00'}{" "}
                      <img
                        src="/assets/images/white-sar.svg"
                        alt=""
                        className="inline-block align-baseline"
                      />
                    </div>
                  </div>
                  <NormalButton
                    isDisabled={vendor.credits <= 0}
                    label={t('wallet.withdrawBalance')}
                    full
                    color={
                      "!bg-blue !mb-[10px] transition-transform hover:scale-105"
                    }
                    onClick={() => handleWithDrawWallet()}
                  />
                  <NormalButton
                    label={t('wallet.rechargeWallet')}
                    full
                    color={"!bg-darkBlue transition-transform hover:scale-105"}
                    onClick={() => handleClickRechargeWallet()}
                  />
                </div>
              </div>
            </MainContent>
          )}
        </PageMain>
      </div>
      {rechargeModal && (
        <ModalContainer
          heading={t('wallet.rechargeModal')}
          handleCloseModal={handleCloseModal}
        >
          <div className="flex flex-nowrap gap-x-[10px]">
            <div className="relative w-[calc(100%-103px)] ltr:w-[calc(100%-163px)]">
              <img
                src="/assets/images/SAR-med.svg"
                alt=""
                className="absolute end-[15px] w-[17px] bottom-[26px] z-[1] select-none"
              />
              <InputField
                label={t('wallet.rechargeAmountLabel')}
                value={rechargeAmount}
                onChange={(e) => {
                  if (
                    e.target.value === "" ||
                    (e.target.value > 0 && /^[0-9\b]+$/.test(e.target.value))
                  ) {
                    setRechargeAmount(e.target.value);
                  }
                }}
              />
            </div>
            <div className="w-[103px] pt-[24px]">
              <NormalButton
                label={t('wallet.recharge')}
                isDisabled={isRechargeDisabled}
                onClick={() => handleRechargeAction()}
              />
            </div>
          </div>
        </ModalContainer>
      )}

      {withDrawWalletModal && (
        <ModalContainer heading={t('wallet.withdrawModal')} handleCloseModal={handleCloseModal}>
          <div className="">
            <p className="font-[600] text-[16px] text-grey-900 mb-[20px]">
              {t('wallet.withdrawDescription')}
            </p>
            <div className="border-b-[1px] border-grey-200 mb-[20px] pb-[20px]">
              <label className="font-[700] text-[12px] text-grey-900">
                {t('wallet.registeredPhone')}
              </label>
              <span
                className="block text-end font-[400] text-[16px] text-grey-600 mt-[5px]"
                dir="ltr"
              >
                +{vendor?.username}
              </span>
            </div>
          </div>
          <div className="">
            <div className="relative w-full">
              <img
                src="/assets/images/SAR-med.svg"
                alt=""
                className="absolute end-[15px] w-[17px] bottom-[15px] z-[1] select-none"
              />
              <InputField
                label={t('wallet.withdrawAmountLabel')}
                value={withDrawAmount}
                onChange={(e) => {
                  if (
                    e.target.value === "" ||
                    (e.target.value > 0 && /^[0-9\b]+$/.test(e.target.value))
                  ) {
                    setWithDrawAmount(e.target.value);
                  }
                }}
              />
            </div>
            <div className="w-full text-end">
              <div className="pt-[14px] inline-block">
                <NormalButton
                  label={t('wallet.cancel')}
                  color={"!bg-[transparent] !text-grey-400"}
                  isDisabled={false}
                  onClick={() => handleCloseModal()}
                />
              </div>
              <div className="pt-[14px] w-[159px] ltr:w-[280px] inline-block">
                <NormalButton
                  label={t('wallet.withdrawBalance')}
                  isDisabled={iswithDrowDisabled}
                  onClick={() => handleWithDrawWalletAction()}
                />
              </div>
            </div>
          </div>
        </ModalContainer>
      )}

      {showExportModal && (
        <ModalContainer
          maxWidth={"562px"}
          heading={t('wallet.exportModal')}
          handleCloseModal={""}
        >
          <div className="text-[16px] font-[400] text-grey-600">
            <span
              className="w-[24px] h-[24px] inline-block !bg-contain !bg-no-repeat align-middle me-[5px]"
              style={{ background: "url('/assets/images/calendar.svg')" }}
            ></span>
            {t('wallet.exportDescription')}
          </div>
          <div
            className="w-[104px] h-[114px] mx-auto my-[25px]"
            style={{ background: "url('/assets/images/pdf.svg')" }}
          ></div>
          <div className="flex flex-nowrap gap-x-[10px]">
            <div className="w-[50%]">
              <div
                className="text-center cursor-pointer select-none text-grey-800 bg-white border-[1px] border-grey-800 rounded-[8px] h-[48px] leading-[48px] font-[600] text-[18px]"
                onClick={""}
              >
                {t('wallet.cancel')}
              </div>
            </div>
            <div className="w-[50%]">
              <div
                className="text-center cursor-pointer select-none text-white bg-grey-800 rounded-[8px] h-[48px] leading-[48px] font-[600] text-[18px]"
                onClick={() => ""}
              >
                {t('wallet.downloadFile')}
              </div>
            </div>
          </div>
        </ModalContainer>
      )}
      <Toast toast={toast} setToast={setToast} />
      {(!vendor || !transactions) && <Loading showLoading={true} />}
    </>
  );
};

export default WalletPage;
